import React from 'react';
import ReactDOM from 'react-dom/client';
import { Root } from './app/root';
import './styles/global.css';
import { installNativeBack } from './app/nativeBack';

installNativeBack();

const rootEl = document.getElementById('root');
if (!rootEl) throw new Error('Missing #root element');

ReactDOM.createRoot(rootEl).render(
  <React.StrictMode>
    <Root />
  </React.StrictMode>,
);
